import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'global'
})
export class GlobalPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}

@Pipe({
  name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {

  transform(value: any): number {
    return Number(value)
  }
}

@Pipe({
  name: 'toString'
})
export class ToStringPipe implements PipeTransform {

  transform(value: any): string | null {
    if(value) return value.toString()
      else return null

  }
}
